import {GenericException} from '../../../allkey/framework/message/GenericException';

export class ConnectException extends GenericException {}

